import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { useTheme } from '@mui/material/styles';

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Bs4Tooltip from '../Bs4Components/Bs4Tooltip';

import Autocomplete from '@mui/material/Autocomplete';

import {getBs4Style} from '../Bs4Components/Bs4Utils'

export const formatterSelect = (cell, formatterParams, onRendered) => {
  const value = String(cell.getValue());
  const element = cell.getElement();
  if (!value) return value;
  const objectValue = formatterParams.find(optin => String(optin.id) === value);  
  if (objectValue && element) {
    const bs4Style = getBs4Style(objectValue?.style);
    element.style.color = bs4Style?.color || null;
    element.style.backgroundColor = bs4Style?.backgroundColor || null;
  }
  return objectValue?.name;
}

export function editorSelect(cell, onRendered, success, cancel, editorParams){
  const editor = document.createElement("div");
  editor.style.width = "100%";
  editor.style.height = "100%";
  const styleBorder = cell.getElement().style.border
  cell.getElement().style.border = 'none';
  
  const value = cell.getValue();

  const root = createRoot(editor);

  const bs4Success = (value) => {
    console.log('...ColumnsSelect.bs4Success...', value)
    cell.getElement().style.border = styleBorder;
    root.unmount()
    success(value);
  }

  onRendered(() => {
    console.log('...ColumnsSelect.onRendered...', value)
    root.render(
      <ViewComponentSelect
        value={value} 
        options={editorParams.values} 
        multiple={editorParams.multiselect} 
        editorParams={editorParams}
        bs4Success={bs4Success}
        cancel={cancel}
        cell={cell}
        editor={editor}
      />);      
  });
  
  return editor;
}

const ViewOption = (props) => {
  if (props?.option &&  !('bs4Style' in props.option)) props.option.bs4Style = getBs4Style(props?.option?.style, {})
  
  //props.props.className = null;

  return (
    <Stack
      direction="row"
      justifyContent="flex-start"
      {...props.props}
      style={{paddingLeft:8, paddingRight:8, paddingTop:4, paddingBottom:4}}
    >
      <Box
        flex={1}
        borderRadius={1}
        px={0.5}
        sx={props.option.bs4Style}    
      >
        <Typography>{props?.option?.name}</Typography>
      </Box>
    </Stack>
  );
};

const ViewComponentSelect = (props) => {
  const theme = useTheme();
  const [value, setValue] = React.useState(() => props.options.find(option => String(option.id) === String(props.value)));
  const refResize = React.useRef()
  const awayRef = React.useRef({
    mouseTextField: true,
  });
      
  const onClose = (event, reason) => {
    event.stopPropagation();
    if (reason === 'selectOption') {
      if (value)props.bs4Success(value.id);
      props.bs4Success(null);
    }
  }

  const onchange = (event, newValue) => {
    event.stopPropagation();
    setValue(newValue)
    if (newValue) props.bs4Success(newValue.id);
    props.bs4Success(null);
  }

  const onBlurTextField = (e) => {
    if (e.stopImmediatePropagation) e.stopImmediatePropagation()
    e.stopPropagation();

    if (awayRef.current.mouseTextField) {
      if (value) props.bs4Success(value.id);
      props.bs4Success(null);
    }    
  }

  const onKeyDownTextField = (e) => {
    switch(e.keyCode){
      case 13: //Enter
        props.bs4Success(value.map(option => option.id));
        break;

      case 9: //Tab
        awayRef.current.mouseTextField = true
        break;

      case 27:  //Esc
        props.cancel();
        break;

      case 38: //up arrow
      case 40: //down arrow
        if (props?.editorParams?.verticalNavigation === "editor"){
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          e.stopPropagation();
        } else {          
          awayRef.current.mouseTextField = true
        }
        break;

      case 35:
      case 36:
        e.stopPropagation();
        break;

      default:
        break;
    }
  }  

  React.useEffect(() => {
    //new ResizeObserver((e) => props.cell.getRow().normalizeHeight()).observe(refResize.current);
    // !!! resizeobserver loop limit exceeded at ...
    let resizeObserverTimeout = null;
    new ResizeObserver((e) => {
      clearTimeout(resizeObserverTimeout);
      resizeObserverTimeout = setTimeout(() => {
        props.cell.getRow().normalizeHeight();
      }, 50);
    }).observe(refResize.current);
  }, [props.cell]);
  
  console.log('...ColumnsSelect.View...', value, props)

  return (
    <Autocomplete
      fullWidth 
      openOnFocus
      value={(value)}
      onClose={onClose}
      onChange={onchange}
      options={props.options}
      getOptionLabel={option => option?.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => {
        //params.InputProps.disableUnderline = true;
        return (
          <TextField              
            {...params} 
            onBlur={onBlurTextField}
            onMouseEnter={(e) => awayRef.current.mouseTextField = false}
            onMouseLeave={(e) => awayRef.current.mouseTextField = true}
            onKeyDown={onKeyDownTextField}
            autoFocus
            margin='dense'
            fullWidth
            ref={refResize}
            size="small"
            variant="outlined"
            sx={{mt:'1px', mb:'1px', my:'1px', '& input': { padding: 0.5}}}
          />
        )
      }}              
      renderOption={(props, option, { selected }) => <ViewOption key={option.id} props={props} option={option}/>}
    />
  );
}
